<template>
    <div class="d-flex flex-column w-100">

        <div>
            <TopBar v-bind:title="title"/>
        </div>

        <div class="d-flex flex-grow-1">
            <MainMenu class="main-menu"/>
            <ContentContainer class="content-container flex-grow-1" />
        </div>
    </div>
</template>

<script>
    import MainMenu from 'components/mainmenu/MainMenu.vue'
    import TopBar from 'components/TopBar.vue'
    import ContentContainer from 'components/ContentContainer.vue'

    export default {
        name: "MainAppContainer",
        components: {
            TopBar,
            ContentContainer,
            MainMenu
        },
        data: () => {
            return {
                title: 'Appwork Business Manager'
            }
        }
    }
</script>

<style scoped>


    /*
    .main-menu {
        width: 300px;
        max-width: 300px;
        padding: 2rem 1rem;
        font-size: 0.9rem;
    }
    */

    .content-container {
        margin: 1rem;
        display: flex;
        overflow: hidden;
    }
</style>